
import proto from './proto'
import dev from './dev'
import prod from './prod'

const environmentMap = {
  'csp-dev.courtyardstone.com': 'dev',
  'portal.courtyardstone.com': 'prod'
}

const detectedEnvironment = environmentMap[window.location.hostname]
const fallbackEnvironment = 'proto'

console.log('Utilizing %s config', detectedEnvironment || fallbackEnvironment)

const config = {
  state: {
    /**
     * Company name for heeaders and footers
     */
    company: 'Courtyard Stone & Landscape Inc.',
    companyPhoneNumber: '2483093136',

    /**
     * First copyright year for the footer and other places
     */
    copyrightStart: '2014',

    /**
     * The links to the social media accounts
     */
    socialLinks: {
      'Houzz': {
        'link': 'http://www.houzz.com/pro/ben-reinhold/courtyard-stone-landscape-inc',
        'fa': 'houzz'
      },
      'Facebook': {
        'link': 'http://www.facebook.com/courtyardstone',
        'fa': 'facebook'
      },
      'Flicker': {
        'link': 'http://www.flickr.com/photos/courtyardstone/',
        'fa': 'flickr'
      },
      'Pintrest': {
        'link': 'http://www.pinterest.com/courtyardstone/',
        'fa': 'pinterest-p'
      }
    },
    locale: 'en-US',
    phoneNumberMask: '(999) 999-9999',
    zipMask: '99999[-9999]',
    zipRegex: /^\d{5}(?:-\d{4})?$/,

    environment: {
      proto: proto,
      dev: dev,
      prod: prod
    }
  },
  getters: {
    environmentName: function (state) {
      return detectedEnvironment || fallbackEnvironment
    },

    amazonSignInParams: function (state, getters) {
      return state.environment[getters.environmentName].amazonSignInParams
    },

    facebookSignInParams: function (state, getters) {
      return state.environment[getters.environmentName].facebookSignInParams
    },

    googleSignInParams: function (state, getters) {
      return state.environment[getters.environmentName].googleSignInParams
    },

    cognitoIdentityPoolId: function (state, getters) {
      return state.environment[getters.environmentName].cognitoIdentityPoolId
    },

    apiGatewayEndpoint: function (state, getters) {
      return state.environment[getters.environmentName].apiGatewayEndpoint
    },

    awsRegion: function (state, getters) {
      return state.environment[getters.environmentName].awsRegion
    },

    signinTimeout: function (state, getters) {
      return state.environment[getters.environmentName].signinTimeout
    },

    googleAnalyticsId: function (state, getters) {
      return state.environment[getters.environmentName].googleAnalyticsId
    },

    googleAnalyticsSampleRate: function (state, getters) {
      return state.environment[getters.environmentName].googleAnalyticsSampleRate
    },

    googleAnalyticsSpeedSampleRate: function (state, getters) {
      return state.environment[getters.environmentName].googleAnalyticsSpeedSampleRate
    },

    website: function (state, getters) {
      return state.environment[getters.environmentName].website
    },

    zipMask: function (state, getters) {
      return state.zipMask
    },

    zipRegex: function (state, getters) {
      return state.zipRegex
    },

    /**
     * Copyright line getter which builds the full copyright year range
     */
    copyrightYear: function (state) {
      return state.copyrightStart + ' - ' + new Date().getFullYear()
    },

    company: function (state) {
      return state.company
    },

    companyPhoneNumber: function (state) {
      return state.companyPhoneNumber
    },

    /**
     * Return the object of social Links
     */
    socialLinks: function (state) {
      return state.socialLinks
    },

    /**
     * Default display locale
     */
    locale: function (state) {
      return state.locale
    },

    /**
     * Phone Number display mask
     */
    phoneNumberMask: function (state) {
      return state.phoneNumberMask
    }
  }
}

export default config



// WEBPACK FOOTER //
// ./src/store/config/index.js